var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-12", attrs: { id: "availabilities-base" } },
    [
      _c(
        "div",
        {
          staticClass:
            "h-12 flex flex-shrink-0 pt-2 px-6 gap-4 fixed top-18 left-0 z-30 bg-pure-white border-b border-slate-400",
          style: { width: "calc(100vw - 0.5rem)" }
        },
        _vm._l(_vm.tabs, function(tab) {
          return _c(
            "router-link",
            {
              key: tab.target,
              staticClass:
                "w-full flex items-center justify-center transition-all duration-300 border-b-4",
              class: tab.isActive ? "border-light-purple" : "border-pure-white",
              attrs: { to: tab.target }
            },
            [
              tab.isActive
                ? _c("BlTextSubtitle2", { attrs: { text: tab.label } })
                : _c("BlTextBody1", { attrs: { text: tab.label } })
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "availabilities-body" } },
        [
          !_vm.$route.params.tab
            ? _c("Room", {
                attrs: {
                  timeslotView: _vm.timeslotView,
                  timeslotViewOptions: _vm.timeslotViewOptions
                },
                on: {
                  "set-timeslot-view": function($event) {
                    _vm.timeslotView = $event
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.$route.params.tab === "therapist"
            ? _c("Therapist", {
                attrs: {
                  timeslotView: _vm.timeslotView,
                  timeslotViewOptions: _vm.timeslotViewOptions
                },
                on: {
                  "set-timeslot-view": function($event) {
                    _vm.timeslotView = $event
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17880ce2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17880ce2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/availabilities/Availabilities.vue
// module id = null
// module chunks = 